import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_REJECT_CASE_TAG_SUGGESTION_BEGIN,
  CASE_REJECT_CASE_TAG_SUGGESTION_SUCCESS,
  CASE_REJECT_CASE_TAG_SUGGESTION_FAILURE,
  CASE_REJECT_CASE_TAG_SUGGESTION_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

export const rejectCaseTagSuggestion = createPromiseAction(CASE_REJECT_CASE_TAG_SUGGESTION_BEGIN);

export function dismissRejectCaseTagSuggestionFeedback() {
  return {
    type: CASE_REJECT_CASE_TAG_SUGGESTION_DISMISS_FEEDBACK,
  };
}

export function* doRejectCaseTagSuggestion(action) {
  const { caseId, suggestionName } = action.payload;
  const res = yield call(api.post, `/cases/${caseId}/tags/suggestions/reject`, {
    suggestionName,
  });

  if (res && res.error) {
    yield put({
      type: CASE_REJECT_CASE_TAG_SUGGESTION_FAILURE,
      feedback: {
        message: 'feedback.rejectCaseTagSuggestionFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_REJECT_CASE_TAG_SUGGESTION_SUCCESS,
    data: {
      suggestionName,
    },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchRejectCaseTagSuggestion() {
  yield takeEvery(rejectCaseTagSuggestion, withCurrentCaseId(doRejectCaseTagSuggestion));
}

export function useRejectCaseTagSuggestion() {
  const dispatch = useDispatch();

  const boundAction = useCallback(
    (...args) => {
      return dispatch(rejectCaseTagSuggestion(...args));
    },
    [dispatch],
  );

  const boundDismissFeedback = useCallback(() => {
    return dispatch(dismissRejectCaseTagSuggestionFeedback());
  }, [dispatch]);

  return {
    rejectCaseTagSuggestion: boundAction,
    dismissRejectCaseTagSuggestionFeedback: boundDismissFeedback,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_REJECT_CASE_TAG_SUGGESTION_BEGIN + '.TRIGGER':
      return {
        ...state,
        rejectCaseTagSuggestionPending: true,
        rejectCaseTagSuggestionFeedback: null,
        rejectCaseTagSuggestionTarget: action.payload?.suggestionName || null,
      };

    case CASE_REJECT_CASE_TAG_SUGGESTION_SUCCESS:
      return {
        ...state,
        rejectCaseTagSuggestionPending: false,
        rejectCaseTagSuggestionFeedback: action.feedback,
        rejectCaseTagSuggestionTarget: null,
        caseTagSuggestions: Array.isArray(state.caseTagSuggestions)
          ? state.caseTagSuggestions.filter(
              (suggestion) => suggestion.name !== action.data.suggestionName,
            )
          : state.caseTagSuggestions,
      };

    case CASE_REJECT_CASE_TAG_SUGGESTION_FAILURE:
      return {
        ...state,
        rejectCaseTagSuggestionPending: false,
        rejectCaseTagSuggestionFeedback: action.feedback,
        rejectCaseTagSuggestionTarget: null,
      };

    case CASE_REJECT_CASE_TAG_SUGGESTION_DISMISS_FEEDBACK:
      return {
        ...state,
        rejectCaseTagSuggestionFeedback: null,
      };

    default:
      return state;
  }
}
